const updates = [
  { time: '10分钟前', title: '某知名艺人深夜密会神秘女子，疑似恋情曝光', tag: '娱乐圈', hot: true },
  { time: '28分钟前', title: '某直播平台头部主播涉嫌偷税被调查，金额惊人', tag: '网红', hot: true },
  { time: '1小时前', title: '某科技公司产品发布会前夜，核心参数遭内部泄密', tag: '科技', hot: false },
  { time: '2小时前', title: '知名企业家私人飞机降落后被拍到与神秘人会面', tag: '财经', hot: true },
  { time: '3小时前', title: '某综艺节目录制现场发生冲突，导演组紧急叫停', tag: '综艺', hot: false },
  { time: '4小时前', title: '网曝某品牌食品添加剂超标三倍，官方紧急回应', tag: '社会', hot: true },
  { time: '6小时前', title: '某影视剧组女二号疑似带资进组引发团队不满', tag: '影视', hot: false },
  { time: '8小时前', title: '知名高校教授学术造假事件后续：多人被停职调查', tag: '教育', hot: false },
  { time: '12小时前', title: '某地产巨头资金链断裂传闻四起，内部文件流出', tag: '财经', hot: true },
];

export default function Updates() {
  return (
    <section id="updates" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm text-accent-600 font-medium bg-accent-50 px-3 py-1 rounded-full">实时快讯</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950">最新爆料</h2>
          <p className="mt-2 text-sm text-foreground-500">实时追踪最新爆料事件，不放过每一个热点</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 border-l-2 border-primary-200 space-y-8">
            {updates.map((item, index) => (
              <div key={index} className="relative">
                <div className={`absolute -left-[33px] top-1 w-4 h-4 rounded-full border-2 ${item.hot ? 'border-primary-500 bg-primary-100' : 'border-secondary-400 bg-secondary-100'}`}>
                  {item.hot && <span className="absolute inset-0 rounded-full bg-primary-500 animate-ping opacity-30"></span>}
                </div>
                <div className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-200 transition-colors cursor-pointer">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                    <span className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">{item.tag}</span>
                    {item.hot && (
                      <span className="text-xs px-2 py-0.5 bg-primary-100 text-primary-600 rounded-full flex items-center gap-1 whitespace-nowrap">
                        <i className="ri-fire-line text-[10px]"></i>热门
                      </span>
                    )}
                  </div>
                  <h3 className="text-sm md:text-base font-medium text-foreground-800 leading-relaxed">{item.title}</h3>
                  <div className="mt-3 flex items-center gap-4 text-xs text-foreground-400">
                    <span className="flex items-center gap-1"><i className="ri-eye-line"></i> {(Math.floor(Math.random() * 50) + 10) * 1000} 阅读</span>
                    <span className="flex items-center gap-1"><i className="ri-chat-1-line"></i> {(Math.floor(Math.random() * 200) + 50)} 评论</span>
                    <span className="flex items-center gap-1 cursor-pointer hover:text-primary-500 transition-colors"><i className="ri-share-forward-line"></i> 分享</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}